<template>
  <div class="xiaotaomama-ranking-wrapper" @touchmove.prevent.stop>
    <div
      class="main-wrapper"
      v-if="loading">
      <div class="top">
        <div class="user-nactive">
          <img :src="userInfo.headimgurl">
        </div>
        <div class="text">{{userInfo.share_number}}人气</div>
      </div>
      <div class="main">
        <div class="message">
            温馨提示：若未收到好友助力提醒，请以排行榜人气值为准
        </div>
        <div class="nav">
          <div :class="{active: ajaxJson.flag === 'person'}" @click="typeChange('person')">我的好友</div>
          <div :class="{active: ajaxJson.flag === 'all'}" @click="typeChange('all')">人气排行</div>
        </div>
        <div
          v-if="userList.length"
          class="list"
          @touchmove.stop>
          <div
            class="user-list"
            v-for="(item, index) in userList"
            :key="index">
            <div class="index">
              {{index + 1}}
            </div>
            <div class="img">
              <img :src="item.headimgurl">
            </div>
            <div class="username">
              {{item.nickname}}
            </div>
            <div class="right">已有{{item.share_number}}人气</div>
          </div>
        </div>
        <div
          class="list"
          v-else
        >
          <van-divider>暂无数据</van-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showMessageDialog, goGet } from '@/utils/public'
export default {
  data() {
    return {
      ajaxJson: {
        user_id: '',
        flag: 'person'
      },
      loading: false,
      userList: [],
      userInfo: {}
    }
  },
  methods: {
    getUserId(value) {
      // 获取参数中的UserID
      let query = value || this.$route.query
      if(query.user_id) {
        this.ajaxJson.user_id = query.user_id
        this.getUserInfo()
      } else {
        showMessageDialog({mesg: '没找到对应的用户信息,请联系客服'})
      }
    },
    getUserInfo() {
      // 获取用户信息
      goGet(
        process.env.VUE_APP_MALL_API + '/mall/v2/wechat/ranking_list',
        this.ajaxJson
      ).then(res => {
        if(res.code === 200 && res.data.data.length) {
          let result = res.data.data
          this.loading = true
          this.userInfo = result.shift()
          this.userList = result
        } else {
          showMessageDialog({mesg: '没找到对应的用户信息,请联系客服'})
          this.loading = false
        }
      })
    },
    typeChange(val) {
      if(this.ajaxJson.flag !== 'val') {
        this.ajaxJson.flag = val
        this.getUserInfo()
      }
    }
  },
  mounted() {
    this.getUserId()
  },
  beforeRouteUpdate(from) {
    this.getUserId(from.query)
  }
}
</script>

<style lang="scss" scoped>
.xiaotaomama-ranking-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: rgb(87, 83, 233) url('https://img.taotonggroup.com/202007151117358c9293630.jpg') no-repeat;
  background-size: 100% auto;
  .top {
    overflow: hidden;
    margin-top: 40px;
    width: 100%;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .user-nactive {
      img {
        width: 80px;
        height: 80px;
        overflow: hidden;
        border-radius: 50%;
      }
    }
    .text {
      font-size: 16px;
      color: #fff;
      margin-top: 20px;
      font-weight: bold;
    }
  }
  .main {
    width: 355px;
    border-radius: 18px;
    background: #fff;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    padding: 15px;
    .message {
      width: 100%;
      line-height: 20px;
      border-radius: 6px;
      color: #ff862d;
      background-color: #f3f6f8;
      padding: 8px;
      font-size: 14px;
      height: 56px;
    }
    .nav {
      width: 100%;
      height: 40px;
      margin-top: 10px;
      display: flex;
      justify-content: center;
      border-radius: 20px;
      border: solid 1px rgb(255, 169, 48);;
      box-sizing: border-box;
      overflow: hidden;
      div {
        flex: 1;
        background: #fff;
        font-size: 14px;
        height: 100%;
        color: #666;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          background: rgb(255, 169, 48);
          color: #fff;
          transition: all 0.3s;
        }
      }
    }
    .list {
      margin-top: 20px;
      width: 100%;
      max-height: calc(100vh - 40px - 150px - 10px - 56px - 40px - 20px - 40px);
      overflow-y: auto;
      .user-list {
        height: 55px;
        width: 100%;
        padding: 10px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .index {
          width: 30px;
          font-size: 16px;
          font-weight: bold;
          overflow: hidden;
        }
        .img {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .username {
          width: 150px;
          margin-left: 20px;
          font-size: 14px;
          color: #666;
          height: 35px;
          line-height: 35px;
        }
        .right {
          width: 80px;
          font-size: 12px;
          text-align: right;
          overflow: hidden;
          color: #666;
          height: 35px;
          line-height: 35px;
        }
      }
    }
  }
}
</style>
